module.exports = __webpack_public_path__ + "img/worm_gear_cylinder_right.prt.d5d075ad.jpg";